import { useNavigate } from "react-router-dom";
import PlayerListContainer from "../../components/PlayerListContainer";
import "../../assets/css/PlayerList.css";
import { IoMdSearch } from "react-icons/io";
import CustomButton from "../../components/CustomButton";
import { useEffect, useState } from "react";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { useSelector } from "react-redux";
import FilterIcon from '../../assets/images/Filter.png';
import { useLocation } from "react-router-dom";
import Layout from "../../layouts/Layout";
import GameSearchFilter from "../gamesearchfilter/GameSearchFilter";
import { RxCross2 } from "react-icons/rx";
import { HashLoader } from "react-spinners";
import { IoIosArrowDropleft } from "react-icons/io";
import { FaHeart } from "react-icons/fa";
import PlayerList from "../playerList/PlayerList";
import { FaUsers } from "react-icons/fa";
import { MdOutlineNotInterested } from "react-icons/md";
import FilterImg from '../../assets/icons/Filter.png';
import { saveInviteSelectedPlayer } from "../../redux/UserDataSlice";
import { useDispatch } from "react-redux";

const InvitePlayer = () => {
  const [players, setPlayers] = useState([]);
  const [filteredPlayers, setFilteredPlayers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const navigate = useNavigate();
  const { accessToken } = useSelector((state) => state.loginInfo);
  const location = useLocation();
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedView, setSelectedView] = useState('all');
  const dispatch = useDispatch();

  const onPlayerList = () => {
    navigate('/creategame', { state: { invitedPlayers: selectedPlayers } });
  };
  useEffect(() => {
    setSelectedPlayers(JSON.parse(localStorage.getItem("invitedPlayers") || "[]"));
  }, [])

  const handleButtonClick = (player) => {
    setSelectedPlayers((prevSelected) => {
      const isAlreadySelected = prevSelected.some((p) => p.id === player.id);
      let updatedList;

      if (isAlreadySelected) {
        updatedList = prevSelected.filter((p) => p.id !== player.id);
      } else {
        updatedList = [...prevSelected, { id: player.id, name: player.name }];
      }

      localStorage.setItem("invitedPlayers", JSON.stringify(updatedList));
      return updatedList;
    });
  };


  const onButton = (player) => (
    <CustomButton
      id={`player-btn-${player.name}`}
      buttonText={selectedPlayers.some((p) => p.id === player.id) ? "Selected" : "Invite"}
      onClick={() => handleButtonClick(player)}
      style={{
        color: "#fff",
        padding: "8px 12px",
        cursor: "pointer",
        borderRadius: "5px",
        border: "none",
        height: '35px',
        border: '1.5px solid #008000',
      }}
      className={`custom-player-button ${selectedPlayers.some((p) => p.id === player.id) ? "selected-player" : "unselected-player"}`}
    />
  );

  const onGoToBackPage = () => {
    navigate('/creategame', { state: { invitedPlayers: selectedPlayers } });
  };

  useEffect(() => {
    if (location.state?.selectedPlayers) {
      setSelectedPlayers(location.state.selectedPlayers);
    }

    const fetchApi = async () => {
      setLoader(true);
      try {
        const result = await apiHandler({
          url: endpoint.INVITE_GAME,
          method: "GET",
          authToken: accessToken?.accessToken,
        });
        const response = result.data;
        if (response) {
          setLoader(false);
          setPlayers(result.data);
          setFilteredPlayers(result.data);
        }
      } catch (error) {
        setLoader(false);
        console.error("Error fetching players:", error);
      }
    };

    fetchApi();
  }, [accessToken, location.state, refreshData]);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const onCloseFilterModal = (data) => {
    setIsOpen(!isOpen);
    setRefreshData(!refreshData)
  }

  const onCloseModal = () => {
    setIsOpen(!isOpen);
  }


  return (
    <>
      {!loader ?
        <Layout>
          <div className="d-flex justify-content-center align-items-center p-2 p-sm-0 ">
            <div className="container invite-player-container" style={{ width: "100%", margin: "14px" }} >
              <div className="row" >
                <div className="fs-4 fs-sm-5  fw-semibold  ps-3 ps-sm-0 mb-2 mb-sm-0">Invite Players</div>
                <div className="d-flex justify-content-between align-items-center ">
                  <div className='row'>
                    <div className="d-sm-flex justify-content-between align-items-center mb-2">
                      <div className="d-flex ms-2 ms-sm-0">
                        <div>
                          <CustomButton icon={<FaUsers style={{ marginRight: '3px' }} />} buttonText={"All Player"} className={`favorite-plyer-btn ${selectedView === 'all' ? 'active' : ''}`} onClick={() => setSelectedView('all')} />
                        </div>
                      </div>
                      <div className=" mb-1 ms-1 ms-sm-0 mt-2 mt-sm-0 p-sm-2" >
                        <div className="d-sm-flex justify-content-between player-list-search-bar">
                          <div className="d-flex">
                            <CustomButton buttonText={"Favorite Player"} icon={<FaHeart style={{ fontSize: '15px', color: 'white', marginRight: '3px' }} />} className={`favorite-plyer-btn ${selectedView === 'favorite' ? 'active' : ''}`} onClick={() => setSelectedView('favorite')} />
                            <CustomButton buttonText={"Excluded Player"} icon={<MdOutlineNotInterested style={{ color: "white", fontWeight: '600', fontSize: '15px', marginRight: '3px' }} />} className={`favorite-plyer-btn ${selectedView === 'excluded' ? 'active' : ''}`} onClick={() => setSelectedView('excluded')} />
                          </div>
                          <div className="d-flex justify-content-between mt-3 mt-sm-0">
                            <div className="search-bar d-flex justify-content-end me-2">
                              <IoMdSearch className="fs-2 me-2" />
                              <input
                                type="text"
                                placeholder="Search Players..."
                                className="search-input"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                              />
                            </div>
                            <div>
                              <img src={FilterImg} onClick={toggleModal} style={{ cursor: 'pointer' }} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      {(() => {
                        const filteredPreferredUsers = players?.preferredUsers?.filter(player =>
                          player.name?.toLowerCase().includes(searchQuery.toLowerCase())
                        ) || [];

                        const filteredExcludedUsers = players?.excludedUsers?.filter(player =>
                          player.name?.toLowerCase().includes(searchQuery.toLowerCase())
                        ) || [];

                        const filteredAllUsers = players?.allUsers?.filter(player =>
                          player.name?.toLowerCase().includes(searchQuery.toLowerCase())
                        ) || [];

                        const hasResults =
                          filteredPreferredUsers.length > 0 ||
                          filteredExcludedUsers.length > 0 ||
                          filteredAllUsers.length > 0;

                        return hasResults ? (
                          <div>
                            {selectedView === 'favorite' && filteredPreferredUsers.length > 0 && (
                              <>
                                <div className="row gy-3 gy-sm-4 " >
                                  {filteredPreferredUsers.map((player, index) => (
                                    <div className='col-12 col-sm-4 col-lg-4' key={player.id}>
                                      <PlayerListContainer
                                        player={player}
                                        onClick={onPlayerList}
                                        button={onButton(player)}
                                      />
                                    </div>

                                  ))}
                                </div>
                              </>
                            )}

                            {selectedView === 'excluded' && filteredExcludedUsers.length > 0 && (
                              <>
                                <div className="row gy-3 gy-sm-4 " >
                                  {filteredExcludedUsers.map((player, index) => (
                                    <div className='col-12 col-sm-4  col-lg-4' key={player.id}>
                                      <PlayerListContainer
                                        player={player}
                                        onClick={onPlayerList}
                                        button={onButton(player)}
                                      />
                                    </div>

                                  ))}
                                </div>
                              </>
                            )}

                            {selectedView === 'all' && filteredAllUsers.length > 0 && (
                              <>
                                <div className="row gy-3 gy-sm-4 " >
                                  {filteredAllUsers.map((player, index) => (
                                    <div className='col-12 col-sm-4 col-lg-4' key={player.id}>
                                      <PlayerListContainer
                                        player={player}
                                        onClick={onPlayerList}
                                        button={onButton(player)}
                                      />
                                    </div>

                                  ))}
                                </div>
                              </>
                            )}
                          </div>

                        ) : (
                          <div className="d-flex align-items-center justify-content-center" style={{ height: '50vh' }} >
                            <h3 className="text-center py-3" style={{ fontWeight: '600', color: 'rgba(33, 37, 41, 0.75)' }}>No Players Found</h3>
                          </div>
                        );
                      })()}
                    </div>
                  </div>
                </div>
                <div className="text-end mt-4">
                  <CustomButton buttonText={"Submit"} className={`favorite-plyer-btn `} style={{ width: '150px', position: 'fixed', bottom: '21px', right: '5%' }} onClick={onGoToBackPage} />
                </div>
                <div>
                  <div className={`modal-overlay ${isOpen ? "open" : "closeModal"}`}>
                    <div className="modal-content overflow-x-auto">
                      <GameSearchFilter onCloseFilterModal={onCloseFilterModal} onCloseModal={onCloseModal} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Layout>
        :
        <div className="d-flex align-items-center justify-content-center" style={{ height: '55vh' }}>
          < HashLoader color="#e48181" />
        </div>
      }
    </>
  );
};

export default InvitePlayer;
